import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, DialogActions, FormHelperText } from '@material-ui/core'; 
import { useStyles } from 'components/Samples/SampleDetails/LabResultsTab';
import { Alert } from '@material-ui/lab';
import { uploadLabResultAttachment } from 'utils/SampleFormsUtils';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';

const UploadAttachmentDialog = ({ open, onClose, uploadedItem /* change name */, successCallback }) => {
    const classes = useStyles();

    const [ uploadError, setUploadError ] = useState(false);
    const [ fileData, setFileData ] = useState(undefined);
    const [ loading, setLoading ] = useState(false);

    const onChangeHandler = event => setFileData(event.target.files[0]);

    const onClickHandler = () => {
        setLoading(true);
        const formData = new FormData()
        formData.append('value', fileData)
        uploadLabResultAttachment(formData, uploadedItem).then(res => {
            if (res.success) {
                successCallback();
                setLoading(false);
            } else {
                if (res.details.message.includes("already exists")) {
                    setUploadError("File already exists, please rename file and upload again.");
                } else {
                    setUploadError("Error uploading file");
                };
                setLoading(false);
            }
        });
    }

    return (
        <Dialog open={open} onClose={onClose} disableBackdropClick maxWidth={'lg'} >
            {
            !loading ?
            <>
            <DialogTitle id="form-dialog-title" className={classes.cardHeader} >Upload Attachment</DialogTitle>
            <DialogContent>
                {uploadError && <Alert severity="error">{uploadError}</Alert>}
                <FormHelperText>Select PDF file to upload</FormHelperText>
                <div>
                    <input type="file" name="file" onChange={onChangeHandler} />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary"> Cancel</Button>
                <Button color="primary" onClick={onClickHandler}> Attach File </Button>
            </DialogActions>
            </>
            :
            <div style={{width: 75, height: 55}}><CenteredCircularProgress /></div>
            }
        </Dialog>
    )
};

export default UploadAttachmentDialog;